import { Button } from "@/components/ui/button";
import { useDateFormatter } from "@/hooks/useDateFormatter";
import type { RateRow } from "@/types/exchange-rates";

interface Props {
  rows: RateRow[];
  onReuse?: (row: RateRow) => void;
}

export const RateTable = ({ rows, onReuse }: Props) => {
  const { formatDate } = useDateFormatter();
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b">
            <th className="p-3">Conversion direction</th>
            <th className="p-3">Source / period</th>
            <th className="p-3">Valid from</th>
            <th className="p-3">Valid through (inclusive)</th>
            <th className="p-3">Version / change</th>
            {onReuse ? <th className="p-3">Action</th> : null}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.id ?? index} className="border-b">
              <td className="p-3 font-medium">
                1 {row.from_currency} = {row.rate} GBP
              </td>
              <td className="p-3">
                {row.source} · {row.period_label}
              </td>
              <td className="p-3">{formatDate(row.valid_from)}</td>
              <td className="p-3">{formatDate(row.valid_through)}</td>
              <td className="p-3">
                {row.version} · {row.classification ?? (row.is_current ? "Current" : "Historical")}
              </td>
              {onReuse ? (
                <td className="p-3">
                  {row.id && row.is_current ? (
                    <Button variant="outline" size="sm" onClick={() => onReuse(row)}>
                      Add approved rate for missing period
                    </Button>
                  ) : null}
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
      {!rows.length ? <p className="p-5">No exchange rates found.</p> : null}
    </div>
  );
};
